import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

class SocketService {
  socket = null;

  connect(token, userId, userType, organizationId) {
    if (this.socket && this.socket.connected) {
      console.log('Socket already connected');
      return;
    }

    console.log('🔌 Attempting to connect to WebSocket:', {
      url: SOCKET_URL,
      path: '/ws/socket.io',
      userId,
      userType,
      organizationId,
      hasToken: !!token
    });

    this.socket = io(SOCKET_URL, {
      path: '/ws/socket.io',
      auth: {
        token,
        user_id: userId,
        user_type: userType,
        organization_id: organizationId
      },
      transports: ['websocket', 'polling']
    });

    this.socket.on('connect', () => {
      console.log('✅ Connected to WebSocket successfully');
    });

    this.socket.on('disconnect', (reason) => {
      console.log('❌ Disconnected from WebSocket. Reason:', reason);
    });

    this.socket.on('connect_error', (error) => {
      console.error('❌ Socket connection error:', error);
      console.error('Error message:', error.message);
      console.error('Error type:', error.type);
    });

    this.socket.on('error', (error) => {
      console.error('❌ Socket error:', error);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  // Send a message
  sendMessage(conversationId, content, recipientId) {
    if (this.socket) {
      this.socket.emit('send_message', {
        conversation_id: conversationId,
        content,
        recipient_id: recipientId
      });
    }
  }

  // Send typing indicator
  sendTyping(conversationId, isTyping) {
    if (this.socket) {
      this.socket.emit('typing', {
        conversation_id: conversationId,
        is_typing: isTyping
      });
    }
  }

  // Mark messages as read
  markAsRead(conversationId) {
    if (this.socket) {
      this.socket.emit('mark_read', {
        conversation_id: conversationId
      });
    }
  }

  // Listen for new messages
  onNewMessage(callback) {
    if (this.socket) {
      this.socket.on('new_message', callback);
    }
  }

  // Listen for typing indicators
  onUserTyping(callback) {
    if (this.socket) {
      this.socket.on('user_typing', callback);
    }
  }

  // Listen for read receipts
  onMessagesRead(callback) {
    if (this.socket) {
      this.socket.on('messages_read', callback);
    }
  }

  // Listen for user presence updates (online/offline)
  onUserPresence(callback) {
    if (this.socket) {
      this.socket.on('user_presence', callback);
    }
  }

  // Remove listeners
  off(event) {
    if (this.socket) {
      this.socket.off(event);
    }
  }

  isConnected() {
    return this.socket && this.socket.connected;
  }
}

const socketService = new SocketService();
export default socketService;
